// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JphH","colBig":"styles_colBig__2Wld4","colSmall":"styles_colSmall__2IKX_"};